import { Card, Checkbox, Form, Radio, Row, Col, Typography, theme } from "antd";
import React from "react";
import { attentionCheckboxOptions } from "../../../../Options/physioOptions";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";

const Attention = ({ psych = false, setAttention, ipLikeUi = false }) => {
  const { token } = theme.useToken();

  const attentionFields = [
    {
      label: "Repeat the following in forward order",
      sequence: "2 1 8 5 4",
      value: "attention_1",
    },
    {
      label: "Repeat the following in backward order",
      sequence: "7 4 2",
      value: "attention_2",
    },
    {
      label: "Repeat the list and tap hand on occurrence of A",
      sequence: "F B A C M N A A J K L B A F A K D E A A A J A M O F A A B",
      value: "attention_3",
    },
  ];

  const handleChange = (value, fieldValue) => {
    setAttention((prev) => ({
      ...prev,
      [fieldValue]: value,
    }));
  };

  const styles = {
    body: {
      display: "flex",
      minHeight: 171,
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    },
  };

  return (
    <Row
      className="attention-grid"
      gutter={[16, 16]}
      justify="center"
      style={{
        width: "100%",
        margin: 0,
      }}
    >
      {attentionFields.map((field) => (
        <Col
          key={field.value}
          className="attention-card-col"
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
        >
          <Card
            className="attention-dark-card"
            bordered={false}
            styles={{
              body: {
                width: "100%",
                boxSizing: "border-box",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 180,
              },
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              background: token.colorPrimary,
              border: `1px solid ${token.colorBorderSecondary}`,
              borderRadius: 10,
            }}
          >
            <Typography style={{ textAlign: "center", width: "100%" }}>
              <Typography.Text className="attention-heading-text">
                {field.label}
              </Typography.Text>
              <Typography.Text strong className="attention-sequence-pill">
                {field.sequence}
              </Typography.Text>
            </Typography>
            <Form.Item
              name={
                psych
                  ? ["moca", "attention_data", field.value]
                  : ["attention_data", field.value]
              }
              style={{ width: "100%", marginBottom: 0, marginTop: 12 }}
            >
              <Radio.Group
                className="attention-yesno-group"
                style={{ width: "100%" }}
                onChange={(e) => handleChange(e?.target?.value, field.value)}
              >
                <Row justify="center" gutter={[8, 0]}>
                  <Col>
                    <Radio.Button value="yes" className="like-btn">
                      <LikeOutlined />
                    </Radio.Button>
                  </Col>
                  <Col>
                    <Radio.Button value="no" className="dislike-btn">
                      <DislikeOutlined />
                    </Radio.Button>
                  </Col>
                </Row>
              </Radio.Group>
            </Form.Item>
          </Card>
        </Col>
      ))}

      <Col
        className="attention-card-col"
        xs={24}
        sm={24}
        md={12}
        lg={12}
        xl={12}
        style={{ display: "flex" }}
      >
        <Card
          key="attention_4"
          className="attention-dark-card attention-dark-card--serial"
          bordered={false}
          styles={{
            body: {
              ...styles.body,
              width: "100%",
              boxSizing: "border-box",
              padding: "16px",
            },
          }}
          style={{
            minHeight: 180,
            width: "100%",
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: ipLikeUi ? "#fff" : token.colorPrimary,
            color: ipLikeUi ? "#101828" : token.colorTextLightSolid,
            border: `1px solid ${token.colorBorderSecondary}`,
            borderRadius: 10,
          }}
        >
          <Typography
            style={{ textAlign: "center", marginBottom: 12, width: "100%" }}
          >
            <Typography.Text strong className="attention-heading-text">
              Serial 7 subtraction starting from 100
            </Typography.Text>
          </Typography>
          <Row justify="center" style={{ width: "100%" }}>
            <Col span={24}>
              <Form.Item
                name={
                  psych
                    ? ["moca", "attention_data", "attention_4"]
                    : ["attention_data", "attention_4"]
                }
                style={{ marginBottom: 0 }}
              >
                <Checkbox.Group
                  className="attention-checkbox-group"
                  onChange={(values) => handleChange(values, "attention_4")}
                >
                  <Row gutter={[8, 8]} justify="center">
                    {attentionCheckboxOptions.map((opt) => (
                      <Col key={opt.value} className="attention-checkbox-col">
                        <Checkbox value={opt.value} className="attention-checkbox-option">
                          {opt.label}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default Attention;
